'use client';
import styles from './preference-controls.module.css';

export function ThemeToggle({dark,label,disabled=false,onToggle}:{dark:boolean;label:string;disabled?:boolean;onToggle:()=>void}) {
 return <button type="button" className={styles.control} aria-label={label} title={label} aria-pressed={dark} disabled={disabled} onClick={onToggle}>
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
   {dark?<><circle cx="12" cy="12" r="4"/><path d="M12 2v2m0 16v2M2 12h2m16 0h2M5 5l1.5 1.5m11 11L19 19M5 19l1.5-1.5m11-11L19 5"/></>:<path d="M20 15.5A8.5 8.5 0 0 1 8.5 4 8.5 8.5 0 1 0 20 15.5Z"/>}
  </svg>
 </button>;
}
